import { render, staticRenderFns } from "./bip-grade.vue?vue&type=template&id=c0b03244&"
import script from "./bip-grade.vue?vue&type=script&lang=js&"
export * from "./bip-grade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports